<template>
    <div class="relative">
        <parallax
            :dim="devise.dim.text"
            :background="devise.backgroundImage.url"
            class="text-white"
        >
            <div class="flex justify-center">
                <div class="container py-12 lg:py-16 text-center lg:px-16 min-h-[400px]">
                    <h3 class="mb-4 text-4xl font-sans-lato font-light">
                        {{ devise.title.text }}
                    </h3>
                    <div v-html="devise.description.text" class="px-12"></div>
                </div>
            </div>
        </parallax>
    </div>
</template>

<script>
import Parallax from "./Parallax";

export default {
    name: "CenteredTextParallax",

    components: {
        Parallax
    }
};
</script>
